import { CheckoutCardProvider } from '../../models/checkout-card/checkout-card-provider.enum';
import { WorldpayConfig } from '../../models/worldpay/worldpay-config.interface';
import { WorldpayTransactionSource } from '../../models/worldpay/worldpay-transaction-source.enum';
import { WorldpayTransactionType } from '../../models/worldpay/worldpay-transaction-type.enum';
import { mockWorldpayCustomisation } from './worldpay-customisation.mock';

export const mockWorldpayConfig: WorldpayConfig = {
  customisation: mockWorldpayCustomisation,
  iframeHelperURL: 'iframeHelperUrl',
  provider: CheckoutCardProvider.Worldpay,
  transactionDescription: 'description',
  transactionSource: WorldpayTransactionSource.Web,
  transactionType: WorldpayTransactionType.Web,
};
